import { Component } from '@angular/core';

@Component({
  selector: 'app-cree-bn-recep',
  templateUrl: './cree-bn-recep.component.html',
  styleUrls: ['./cree-bn-recep.component.scss']
})
export class CreeBnRecepComponent {}
